import React from 'react';
import { Camera, Briefcase, Building2, Sparkles, ChevronRight, LogOut } from 'lucide-react';
export function ProfilePage() {
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] overflow-hidden" data-id="element-501">
      {/* Fixed Header */}
      <div className="bg-[#0D0D0D] border-b border-[#2A2A2A]/50 px-6 pt-10 pb-4 flex-shrink-0 z-10 relative" data-id="element-502">
        <h1 className="font-medium text-white text-[17px] tracking-tight" data-id="element-503">
          Profilo
        </h1>
      </div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto min-h-0 px-6 pt-8 pb-12" data-id="element-504">
        {/* Profile Picture & Name */}
        <div className="flex flex-col items-center mb-8" data-id="element-505">
          <div className="relative mb-4" data-id="element-506">
            <div className="w-28 h-28 rounded-full bg-[#141414] border border-[#2A2A2A] flex items-center justify-center overflow-hidden" data-id="element-507">
              <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=face" alt="Profile" className="w-full h-full object-cover" data-id="element-508" />
            </div>
            <button className="absolute bottom-0 right-0 w-8 h-8 bg-[#C5D82D] rounded-full flex items-center justify-center border-2 border-[#0D0D0D] shadow-lg active:scale-95 transition-transform" data-id="element-509">
              <Camera className="w-4 h-4 text-[#0D0D0D]" data-id="element-510" />
            </button>
          </div>
          <h2 className="text-[20px] font-medium text-white tracking-tight mb-1" data-id="element-511">
            Marco Rossi
          </h2>
          <p className="text-[14px] text-[#888888]" data-id="element-512">CEO / Founder · EIIS</p>
        </div>

        {/* Recap Card */}
        <div className="bg-[#141414] border border-[#2A2A2A] rounded-2xl p-5 relative overflow-hidden mb-8" data-id="element-513">
          <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-[#C5D82D] to-transparent opacity-40" data-id="element-514" />

          <div className="space-y-5" data-id="element-515">
            {/* Role & Org */}
            <div data-id="element-516">
              <h3 className="text-[11px] font-medium text-[#888888] uppercase tracking-wider mb-2 flex items-center gap-1.5" data-id="element-517">
                <Briefcase className="w-3.5 h-3.5" data-id="element-518" />
                Ruolo
              </h3>
              <p className="text-[15px] text-white font-medium" data-id="element-519">
                CEO / Founder
              </p>
              <p className="text-[13px] text-[#888888] flex items-center gap-1.5 mt-1" data-id="element-520">
                <Building2 className="w-3.5 h-3.5" data-id="element-521" />
                EIIS
              </p>
            </div>

            <div className="w-full h-[1px] bg-[#2A2A2A]" data-id="element-522" />

            {/* Themes */}
            <div data-id="element-523">
              <h3 className="text-[11px] font-medium text-[#888888] uppercase tracking-wider mb-2" data-id="element-524">
                Temi di interesse
              </h3>
              <div className="flex flex-wrap gap-2" data-id="element-525">
                <span className="px-3 py-1.5 rounded-full bg-[#1A1A1A] border border-[#2A2A2A] text-[#E0E0E0] text-[12px] font-medium" data-id="element-526">
                  Clima e Ambiente
                </span>
                <span className="px-3 py-1.5 rounded-full bg-[#1A1A1A] border border-[#2A2A2A] text-[#E0E0E0] text-[12px] font-medium" data-id="element-527">
                  Tech e Innovazione
                </span>
              </div>
            </div>

            <div className="w-full h-[1px] bg-[#2A2A2A]" data-id="element-528" />

            {/* Project */}
            <div data-id="element-529">
              <h3 className="text-[11px] font-medium text-[#888888] uppercase tracking-wider mb-2 flex items-center gap-1.5" data-id="element-530">
                <Sparkles className="w-3.5 h-3.5 text-[#C5D82D]" data-id="element-531" />
                Progetto
              </h3>
              <p className="text-[14px] text-white font-medium leading-snug mb-1" data-id="element-532">
                Piattaforma di tracciabilità per la filiera del cacao
              </p>
              <div className="flex gap-1.5 mt-2" data-id="element-533">
                <span className="px-2 py-0.5 rounded-md bg-[#C5D82D]/10 text-[#C5D82D] text-[10px] font-medium uppercase tracking-wider" data-id="element-534">
                  Generato dall'AI
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Settings / Actions */}
        <div className="flex flex-col gap-2" data-id="element-535">
          <button className="flex items-center justify-between bg-[#141414] border border-[#2A2A2A] rounded-xl px-4 py-4 active:scale-[0.99] transition-transform" data-id="element-536">
            <span className="text-[14px] text-white font-medium" data-id="element-537">
              Modifica profilo
            </span>
            <ChevronRight className="w-4 h-4 text-[#888888]" data-id="element-538" />
          </button>

          <button className="flex items-center justify-between bg-[#141414] border border-[#2A2A2A] rounded-xl px-4 py-4 active:scale-[0.99] transition-transform" data-id="element-539">
            <span className="text-[14px] text-white font-medium" data-id="element-540">
              Notifiche
            </span>
            <ChevronRight className="w-4 h-4 text-[#888888]" data-id="element-541" />
          </button>

          <button className="flex items-center justify-between bg-[#141414] border border-[#2A2A2A] rounded-xl px-4 py-4 active:scale-[0.99] transition-transform" data-id="element-542">
            <span className="text-[14px] text-white font-medium" data-id="element-543">
              Informazioni sul Summit
            </span>
            <ChevronRight className="w-4 h-4 text-[#888888]" data-id="element-544" />
          </button>

          <div className="w-full h-[1px] bg-[#2A2A2A] my-2" data-id="element-545" />

          <button className="flex items-center justify-between bg-[#141414] border border-[#2A2A2A] rounded-xl px-4 py-4 active:scale-[0.99] transition-transform" data-id="element-546">
            <span className="text-[14px] text-[#D32F2F] font-medium" data-id="element-547">Esci</span>
            <LogOut className="w-4 h-4 text-[#D32F2F]" data-id="element-548" />
          </button>
        </div>
      </div>
    </div>;
}